const APP_CONF = {
    BASE_URL: process.env.REACT_APP_BASE_URL,
    ITEMS_PER_PAGE: 10,
    APPLICATION_ID: 1,
    TINYMCE_KEY: "kdb3r1voef81zp9ax22krz52kh6v3ou03awk55vy8twfd1oo"
};

export default APP_CONF;
